// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import 'swiper/dist/css/swiper.css';
import './css/common.less'
import axios from 'axios'
import Vant from 'vant';
import 'vant/lib/index.css';


Vue.prototype.http = axios
// axios.defaults.baseURL = 'http://yixiaotao.natapp1.cc'; 
axios.defaults.baseURL = 'https://ytapi.yixiaotao.cn';   //////////////如果url不是绝对路径，那么会将baseURL和url拼接作为请求的接口地址

import VueAMap from 'vue-amap';

import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)

Vue.use(VueAMap);
Vue.use(Vant)

Vue.config.productionTip = false
import components from './components/'
Object.keys(components).forEach((key) => {Vue.component(`v-${key}`, components[key])})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js